import { Component, Input, OnInit, OnDestroy, ViewChild, EventEmitter, Output } from '@angular/core';
import { AddressService } from './address.service';
import { PreloaderHandler, DOTS_FULL } from '../preloader/preloader-handler';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { NotificationHandlerService } from '../notifications/notification-handler.service';
import { AddressModel } from '../models/address-related/AddressModel';
import { ASSOCIATED, ASSOCIATE, NEW } from '../constants';
import { PaginationOutputModel } from '../../pagination/pagination-models/pagination-output.model';
import { AddressSearchParamModel } from '../models/search-related/AddressSearchParamModel';
import { SearchAddressResultModel } from '../models/search-related/SearchAddressResultModel';

declare var $: any;

@Component({
    selector: 'address-modal',
    templateUrl: 'address.component.html'
})

export class AddressComponent implements OnInit {

    public ASSOCIATED_VIEW = ASSOCIATED;
    public ASSOCIATE_VIEW = ASSOCIATE;
    public NEW_VIEW = NEW;

    public entityId: string;
    public preloaderHandler: PreloaderHandler;
    public addresses: AddressModel[];

    public searchAddressResultModel: SearchAddressResultModel;
    public searchParams: AddressSearchParamModel;

    public addressView = ASSOCIATED;
    public newAddress: AddressModel;

    constructor(private _addressService: AddressService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {
        this.searchParams = {
            address: '',
            city: '',
            skip: 0,
            take: 10
        };
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, DOTS_FULL);
        this.initNewAddress();
    }

    ngOnInit(): void {
    }

    private initNewAddress(): void {
        this.newAddress = {
            EntityId: this.entityId,
            DefaultItem: false,
            AddressId: '',
            StreetAddress1: '',
            StreetAddress2: '',
            StreetAddress3: '',
            StreetAddress4: '',
            PostCode: '',
            City: '',
            State: '',
            Country: 'New Zealand',
            UserId: 0
        };
    }

    public showModal(): void {
        $('#addressmodal').modal('open');
    }

    public hideModal(): void {
        $('#addressmodal').modal('close');
    }

    public updateAddressView(view: string): void {
        this.addressView = view;
    }

    public changePage(data: PaginationOutputModel): void {
        this.searchParams.skip = data.skipNum;
        this.searchData();
    }

    public searchData(): void {
        this.preloaderHandler.reset();
        this._addressService.Search(this.searchParams)
            .subscribe((data) => {
                this.searchAddressResultModel = data;
            }, (error) => {
                this._notificationService.handleError(error);
                this.oidcSecurityService.handleError(error);
            }, () => {
                this.preloaderHandler.itemLoaded();
            });
    }

    private getData(entityId: string): void {
        this.entityId = entityId;
        this.preloaderHandler.reset();
        this._addressService.GetAll(entityId)
            .subscribe((data) => {
                this.addresses = data;
            }, (error) => {
                this._notificationService.handleError(error);
                this.oidcSecurityService.handleError(error);
            }, () => {
                this.preloaderHandler.itemLoaded();
            });
    }

    public saveData(newAddressForm: any): void {
        if (newAddressForm.valid) {
            this.preloaderHandler.reset();
            this.newAddress.EntityId = this.entityId;
            this._addressService.Create(this.newAddress)
                .subscribe((result) => {
                }, (error) => {
                    this._notificationService.handleError(error);
                    this.oidcSecurityService.handleError(error);
                }, () => {
                    this.addressView = this.ASSOCIATED_VIEW;
                    this.getData(this.entityId);
                });
        }
    }

    public associateAddress(address: AddressModel): void {
        this.preloaderHandler.reset();
        address.EntityId = this.entityId;
        this._addressService.Update(address)
            .subscribe((result) => {
            }, (error) => {
                this._notificationService.handleError(error);
                this.oidcSecurityService.handleError(error);
            }, () => {
                this.addressView = this.ASSOCIATED_VIEW;
                this.getData(this.entityId);
            });
    }

    public updateDefaultAddress(address: AddressModel): void {
        if (!address.DefaultItem) {
            this.preloaderHandler.reset();
            address.DefaultItem = true;
            this._addressService.Update(address)
                .subscribe((result) => {
                }, (error) => {
                    this._notificationService.handleError(error);
                    this.oidcSecurityService.handleError(error);
                }, () => {
                    this.getData(this.entityId);
                });
        }
    }

    public deleteData(address: AddressModel): void {
        this.preloaderHandler.reset();
        this._addressService.Delete(address)
            .subscribe((result) => {
            }, (error) => {
                this._notificationService.handleError(error);
                this.oidcSecurityService.handleError(error);
            }, () => {
                this.getData(this.entityId);
            });
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/address-modal/address.component.ts